import zxcvbn from 'zxcvbn';

export default class PasswordStrengthMeter {
  constructor(inputElement, containerElement) {
    this.input = inputElement;
    this.container = containerElement;
    this.progressBar = this.container.querySelector('.progress-bar');
    this.strengthText = this.container.querySelector('.password-strength-text');
    this.requirements = this.container.querySelectorAll('[data-requirement]');

    this.init();
  }

  init() {
    this.input.addEventListener('input', () => this.update());
    this.update(); // Esegui subito per lo stato iniziale
  }

  update() {
    const password = this.input.value;
    const result = zxcvbn(password);
    const score = password.length === 0 ? -1 : result.score;

    this.updateProgressBar(score);
    this.updateRequirements(password);
  }

  updateProgressBar(score) {
    const classes = ['progress-bar-danger', 'progress-bar-warning', 'progress-bar-info', 'progress-bar-info', 'progress-bar-success'];
    const labels = {
      '-1': '',
      '0': this.container.dataset.veryWeak || '',
      '1': this.container.dataset.weak || '',
      '2': this.container.dataset.fair || '',
      '3': this.container.dataset.good || '',
      '4': this.container.dataset.strong || ''
    };

    // Reset classi BS3
    this.progressBar.classList.remove('progress-bar-danger', 'progress-bar-warning', 'progress-bar-info', 'progress-bar-success');
    
    let width = 0;
    if (score >= 0) {
      width = (score + 1) * 20;
      if (classes[score]) {
        this.progressBar.classList.add(classes[score]);
      }
    }

    this.progressBar.style.width = `${width}%`;
    this.strengthText.textContent = labels[score] || '';
  }

  updateRequirements(password) {
    const checks = {
      length: password.length >= 8,
      uppercase: /[A-Z]/.test(password),
      lowercase: /[a-z]/.test(password),
      digit: /[0-9]/.test(password),
      special: /[^A-Za-z0-9]/.test(password)
    };

    this.requirements.forEach(req => {
      const type = req.dataset.requirement;
      const isMet = checks[type];
      const icon = req.querySelector('i');

      if (isMet) {
        req.classList.add('text-success');
        req.classList.remove('text-muted');
        icon.className = 'fa-solid fa-circle-check mr-1';
      } else {
        req.classList.remove('text-success');
        req.classList.add('text-muted');
        icon.className = 'fa-solid fa-circle-xmark mr-1';
      }
    });
  }
}
